import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

// Keep non-active pages out of the entry chunk. Each route is fetched only
// when the user navigates to it, while shared components remain in common
// chunks managed by Vite.
const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const Technology = lazy(() => import("../pages/technology/page"));
const Merchant = lazy(() => import("../pages/solutions/merchant/page"));
const Institution = lazy(() => import("../pages/solutions/institution/page"));
const About = lazy(() => import("../pages/about/page"));
const Rules = lazy(() => import("../pages/rules/page"));
const Privacy = lazy(() => import("../pages/privacy/page"));
const Terms = lazy(() => import("../pages/terms/page"));
const Ecosystem = lazy(() => import("../pages/ecosystem/page"));
const Cooperation = lazy(() => import("../pages/cooperation/page"));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/technology", element: <Technology /> },
  { path: "/solutions/merchant", element: <Merchant /> },
  { path: "/solutions/institution", element: <Institution /> },
  { path: "/ecosystem", element: <Ecosystem /> },
  { path: "/cooperation", element: <Cooperation /> },
  { path: "/about", element: <About /> },
  { path: "/rules", element: <Rules /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
